export default "<h3>Transformation API Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"